import { render, staticRenderFns } from "./ModalProductEdit.vue?vue&type=template&id=3594e0f2&scoped=true"
import script from "./ModalProductEdit.vue?vue&type=script&lang=js"
export * from "./ModalProductEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalProductEdit.vue?vue&type=style&index=0&id=3594e0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3594e0f2",
  null
  
)

export default component.exports